import React, { useState } from 'react';
import Form from '../form/Form';
import SliderAuth from '../utils/SliderAuth'
import { Link, useNavigate } from 'react-router-dom';


const initialValues = {
  email: '',
};

const inputsConfig = [
  { label: 'Correo Electrónico', id: 'email', name: 'email', type: 'email', className: 'w-full px-4 py-2 border rounded-md focus:outline-none focus:border-bottom-blue-500', required: true },
];
  
  const SendResetPassword = () => {
    const navigate = useNavigate();

    const onSubmit = (data) => {
        navigate('/reset-password');

    };
  
    const handleError = (err) => {
    };
  
    return (
      <>
          <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <div className="flex w-[800px] flex-col lg:flex-row">

            <SliderAuth/>

              <div className="w-full h-96 flex justify-center items-start flex-col lg:w-3/5 p-8 mb-3 bg-white shadow-lg rounded-xl mt-3">
                <Form
                  initialValues={initialValues}
                  inputsConfig={inputsConfig}
                  onSubmit={onSubmit}
                  handleError={handleError}
                />
                <div className="checkbox-field">
                  <Link to="/login" className="text-decoration-none form-label text-sm text-blue-500 font-semibold">
                    Volver al login
                  </Link>
                </div>
              </div>
            </div>
          </div>
      </>
    );
  };

export default SendResetPassword;

